import React, { Component } from 'react'
import { Redirect } from 'react-router-dom';
import { observer, inject } from 'mobx-react'
import templateServices from '../../services/TemplateServices'
import _ from 'lodash';
import Utils from '../../common/Utils';
import {ViewKeys} from "../../common/Foundation";

/**
 * Author: duc.doi
 */
@inject('LayoutTemplateStore', 'SportsStore')
@observer
class MainComponent extends Component {
  constructor(props) {
    super(props)
    let container = 'bodyContainer';
    let position = 'mainContainer';
    this.dataComps = templateServices.listDataCompsByContainerPosition(props.LayoutTemplateStore, container, position);
    this.state = {
      comps: templateServices.listComponentsByDataNoGrid(this.dataComps, props.router) || (<div></div>)
    }   
  }

  componentDidUpdate(prevProps) {
    const { currentViewContainer } = this.props.LayoutTemplateStore;
    // Update router to child Asia components
    if (currentViewContainer === 'asiaView' && !_.isEqual(prevProps.router, this.props.router)) {
      this.setState({
        comps: templateServices.listComponentsByDataNoGrid(this.dataComps, this.props.router) || (<div></div>)
      });
    }
  }
  
  render() {
    const isValidPage = _.get(this.props, 'LayoutTemplateStore.isValidPage', true);

    // Check valid page. If the page is invalid, browsers will redirect to the Sports page.
    if(!isValidPage) {
      let path = `/${Utils.getCurrentLang()}/`;
      const currenView = Utils.getCurrentView();
      const availableViews = Utils.getAvailableViews();
      const showAsianView = availableViews[ViewKeys.asia];
      const showEuroMobileView = availableViews[ViewKeys.europe];
      const showFutureView = availableViews[ViewKeys.standard];

      if (showFutureView && !showAsianView && !showEuroMobileView) {
        let fvURL = _.get(this.props.LayoutTemplateStore, 'templateData.attributes.fvURL', "");
        if (fvURL) {
          window.location.href = fvURL.replace('{locale}', Utils.getCurrentLang());
          return false;
        }
      }

      return <Redirect to={currenView ? `${path}${currenView}/` : path}/>
    }

    return (
        <div className="body-center">
              {this.state.comps}
        </div>
    );
  }

}

export default MainComponent;


// WEBPACK FOOTER //
// ./src/app/components/MainComponent/index.js